import { useMemo } from 'react';
import { LegalPageLayout } from '../components/legal-page-layout';
import { MarkdownRenderer } from '@/components/ui/markdown-renderer';
import { termsContent } from '../data/terms-content';
import { extractHeadings } from '../utils/extract-headings';

export function TermsPage() {
  const headings = useMemo(() => extractHeadings(termsContent), []);

  return (
    <LegalPageLayout title="Terminos y Condiciones" lastUpdated="Marzo 2026" headings={headings}>
      <MarkdownRenderer content={termsContent} />
    </LegalPageLayout>
  );
}
